import type { Locale } from "locales";
import type { RAlias } from "routes";
import * as Focus0TemplateAr from "./content/ar/focus/0-template.mdx";
import * as Focus1DemandAr from "./content/ar/focus/1-demand.mdx";
import * as Focus2TeachoutfieldAr from "./content/ar/focus/2-teachoutfield.mdx";
import * as Focus3CalendarAr from "./content/ar/focus/3-calendar.mdx";
import * as Focus4SinglesexschoolsAr from "./content/ar/focus/4-singlesexschools.mdx";
import * as Focus5InfrastructureAr from "./content/ar/focus/5-infrastructure.mdx";
import * as Focus6LearningnotlinearAr from "./content/ar/focus/6-learningnotlinear.mdx";
import * as Focus7SafeschoolsAr from "./content/ar/focus/7-safeschools.mdx";
import * as Focus8ScholarshipsssaAr from "./content/ar/focus/8-scholarshipsSSA.mdx";
import * as Focus9IndigenousAr from "./content/ar/focus/9-indigenous.mdx";
import * as Focus10EarlyentryAr from "./content/ar/focus/10-earlyentry.mdx";
import * as Focus11AdulteducationAr from "./content/ar/focus/11-adulteducation.mdx";
import * as Focus12LowperformanceAr from "./content/ar/focus/12-lowperformance.mdx";
import * as Focus13SpendingAr from "./content/ar/focus/13-Spending.mdx";
import * as Focus14HouseholdwealthAr from "./content/ar/focus/14-householdwealth.mdx";
import * as Focus15TaxrevenueAr from "./content/ar/focus/15-taxrevenue.mdx";
import * as Focus16ScholarshipsAr from "./content/ar/focus/16-scholarships.mdx";
import * as Focus17StudentdebtAr from "./content/ar/focus/17-studentdebt.mdx";
import * as Focus18ClimatechangeAr from "./content/ar/focus/18-climatechange.mdx";
import * as Focus19NumeracyskillsAr from "./content/ar/focus/19-numeracyskills.mdx";
import * as Focus20ComputationalthinkingAr from "./content/ar/focus/20-computationalthinking.mdx";
import * as Focus21WritingtoolsAr from "./content/ar/focus/21-writingtools.mdx";
import * as Focus22MicrodredentialsAr from "./content/ar/focus/22-microdredentials.mdx";
import * as Focus23FirstgenerationAr from "./content/ar/focus/23-firstgeneration.mdx";
import * as Focus24ReadingspeedAr from "./content/ar/focus/24-readingspeed.mdx";
import * as Focus25SchoolbuildingAr from "./content/ar/focus/25-schoolbuilding.mdx";
import * as Focus26SolarenergyAr from "./content/ar/focus/26-solarenergy.mdx";
import * as Focus27OnlinesearchAr from "./content/ar/focus/27-onlinesearch.mdx";
import * as Focus28MathanxietyAr from "./content/ar/focus/28-mathanxiety.mdx";
import * as Focus29EcceleadersAr from "./content/ar/focus/29-ecceleaders.mdx";
import * as Focus30TeachleadershipAr from "./content/ar/focus/30-teachleadership.mdx";
import * as Focus31PeereffectsAr from "./content/ar/focus/31-peereffects.mdx";
import * as Focus32CiviceduAr from "./content/ar/focus/32-civicedu.mdx";
import * as Focus33ClimateinfraAr from "./content/ar/focus/33-climateinfra.mdx";
import * as Focus34NsascholarshipsAr from "./content/ar/focus/34-NSAscholarships.mdx";
import * as Focus35TeachershortageAr from "./content/ar/focus/35-teachershortage.mdx";
import * as Focus36PrincipalsalariesAr from "./content/ar/focus/36-principalsalaries.mdx";
import * as Focus37ClimatefinAr from "./content/ar/focus/37-climatefin.mdx";
import * as Focus0TemplateDe from "./content/de/focus/0-template.mdx";
import * as Focus1DemandDe from "./content/de/focus/1-demand.mdx";
import * as Focus2TeachoutfieldDe from "./content/de/focus/2-teachoutfield.mdx";
import * as Focus3CalendarDe from "./content/de/focus/3-calendar.mdx";
import * as Focus4SinglesexschoolsDe from "./content/de/focus/4-singlesexschools.mdx";
import * as Focus5InfrastructureDe from "./content/de/focus/5-infrastructure.mdx";
import * as Focus6LearningnotlinearDe from "./content/de/focus/6-learningnotlinear.mdx";
import * as Focus7SafeschoolsDe from "./content/de/focus/7-safeschools.mdx";
import * as Focus8ScholarshipsssaDe from "./content/de/focus/8-scholarshipsSSA.mdx";
import * as Focus9IndigenousDe from "./content/de/focus/9-indigenous.mdx";
import * as Focus10EarlyentryDe from "./content/de/focus/10-earlyentry.mdx";
import * as Focus11AdulteducationDe from "./content/de/focus/11-adulteducation.mdx";
import * as Focus12LowperformanceDe from "./content/de/focus/12-lowperformance.mdx";
import * as Focus13SpendingDe from "./content/de/focus/13-Spending.mdx";
import * as Focus14HouseholdwealthDe from "./content/de/focus/14-householdwealth.mdx";
import * as Focus15TaxrevenueDe from "./content/de/focus/15-taxrevenue.mdx";
import * as Focus16ScholarshipsDe from "./content/de/focus/16-scholarships.mdx";
import * as Focus17StudentdebtDe from "./content/de/focus/17-studentdebt.mdx";
import * as Focus18ClimatechangeDe from "./content/de/focus/18-climatechange.mdx";
import * as Focus19NumeracyskillsDe from "./content/de/focus/19-numeracyskills.mdx";
import * as Focus20ComputationalthinkingDe from "./content/de/focus/20-computationalthinking.mdx";
import * as Focus21WritingtoolsDe from "./content/de/focus/21-writingtools.mdx";
import * as Focus22MicrodredentialsDe from "./content/de/focus/22-microdredentials.mdx";
import * as Focus23FirstgenerationDe from "./content/de/focus/23-firstgeneration.mdx";
import * as Focus24ReadingspeedDe from "./content/de/focus/24-readingspeed.mdx";
import * as Focus25SchoolbuildingDe from "./content/de/focus/25-schoolbuilding.mdx";
import * as Focus26SolarenergyDe from "./content/de/focus/26-solarenergy.mdx";
import * as Focus27OnlinesearchDe from "./content/de/focus/27-onlinesearch.mdx";
import * as Focus28MathanxietyDe from "./content/de/focus/28-mathanxiety.mdx";
import * as Focus29EcceleadersDe from "./content/de/focus/29-ecceleaders.mdx";
import * as Focus30TeachleadershipDe from "./content/de/focus/30-teachleadership.mdx";
import * as Focus31PeereffectsDe from "./content/de/focus/31-peereffects.mdx";
import * as Focus32CiviceduDe from "./content/de/focus/32-civicedu.mdx";
import * as Focus33ClimateinfraDe from "./content/de/focus/33-climateinfra.mdx";
import * as Focus34NsascholarshipsDe from "./content/de/focus/34-NSAscholarships.mdx";
import * as Focus35TeachershortageDe from "./content/de/focus/35-teachershortage.mdx";
import * as Focus36PrincipalsalariesDe from "./content/de/focus/36-principalsalaries.mdx";
import * as Focus37ClimatefinDe from "./content/de/focus/37-climatefin.mdx";
import * as Focus0TemplateEn from "./content/en/focus/0-template.mdx";
import * as Focus1DemandEn from "./content/en/focus/1-demand.mdx";
import * as Focus2TeachoutfieldEn from "./content/en/focus/2-teachoutfield.mdx";
import * as Focus3CalendarEn from "./content/en/focus/3-calendar.mdx";
import * as Focus4SinglesexschoolsEn from "./content/en/focus/4-singlesexschools.mdx";
import * as Focus5InfrastructureEn from "./content/en/focus/5-infrastructure.mdx";
import * as Focus6LearningnotlinearEn from "./content/en/focus/6-learningnotlinear.mdx";
import * as Focus7SafeschoolsEn from "./content/en/focus/7-safeschools.mdx";
import * as Focus8ScholarshipsssaEn from "./content/en/focus/8-scholarshipsSSA.mdx";
import * as Focus9IndigenousEn from "./content/en/focus/9-indigenous.mdx";
import * as Focus10EarlyentryEn from "./content/en/focus/10-earlyentry.mdx";
import * as Focus11AdulteducationEn from "./content/en/focus/11-adulteducation.mdx";
import * as Focus12LowperformanceEn from "./content/en/focus/12-lowperformance.mdx";
import * as Focus13SpendingEn from "./content/en/focus/13-Spending.mdx";
import * as Focus14HouseholdwealthEn from "./content/en/focus/14-householdwealth.mdx";
import * as Focus15TaxrevenueEn from "./content/en/focus/15-taxrevenue.mdx";
import * as Focus16ScholarshipsEn from "./content/en/focus/16-scholarships.mdx";
import * as Focus17StudentdebtEn from "./content/en/focus/17-studentdebt.mdx";
import * as Focus18ClimatechangeEn from "./content/en/focus/18-climatechange.mdx";
import * as Focus19NumeracyskillsEn from "./content/en/focus/19-numeracyskills.mdx";
import * as Focus20ComputationalthinkingEn from "./content/en/focus/20-computationalthinking.mdx";
import * as Focus21WritingtoolsEn from "./content/en/focus/21-writingtools.mdx";
import * as Focus22MicrodredentialsEn from "./content/en/focus/22-microdredentials.mdx";
import * as Focus23FirstgenerationEn from "./content/en/focus/23-firstgeneration.mdx";
import * as Focus24ReadingspeedEn from "./content/en/focus/24-readingspeed.mdx";
import * as Focus25SchoolbuildingEn from "./content/en/focus/25-schoolbuilding.mdx";
import * as Focus26SolarenergyEn from "./content/en/focus/26-solarenergy.mdx";
import * as Focus27OnlinesearchEn from "./content/en/focus/27-onlinesearch.mdx";
import * as Focus28MathanxietyEn from "./content/en/focus/28-mathanxiety.mdx";
import * as Focus29EcceleadersEn from "./content/en/focus/29-ecceleaders.mdx";
import * as Focus30TeachleadershipEn from "./content/en/focus/30-teachleadership.mdx";
import * as Focus31PeereffectsEn from "./content/en/focus/31-peereffects.mdx";
import * as Focus32CiviceduEn from "./content/en/focus/32-civicedu.mdx";
import * as Focus33ClimateinfraEn from "./content/en/focus/33-climateinfra.mdx";
import * as Focus34NsascholarshipsEn from "./content/en/focus/34-NSAscholarships.mdx";
import * as Focus35TeachershortageEn from "./content/en/focus/35-teachershortage.mdx";
import * as Focus36PrincipalsalariesEn from "./content/en/focus/36-principalsalaries.mdx";
import * as Focus37ClimatefinEn from "./content/en/focus/37-climatefin.mdx";
import * as Focus0TemplateEs from "./content/es/focus/0-template.mdx";
import * as Focus1DemandEs from "./content/es/focus/1-demand.mdx";
import * as Focus2TeachoutfieldEs from "./content/es/focus/2-teachoutfield.mdx";
import * as Focus3CalendarEs from "./content/es/focus/3-calendar.mdx";
import * as Focus4SinglesexschoolsEs from "./content/es/focus/4-singlesexschools.mdx";
import * as Focus5InfrastructureEs from "./content/es/focus/5-infrastructure.mdx";
import * as Focus6LearningnotlinearEs from "./content/es/focus/6-learningnotlinear.mdx";
import * as Focus7SafeschoolsEs from "./content/es/focus/7-safeschools.mdx";
import * as Focus8ScholarshipsssaEs from "./content/es/focus/8-scholarshipsSSA.mdx";
import * as Focus9IndigenousEs from "./content/es/focus/9-indigenous.mdx";
import * as Focus10EarlyentryEs from "./content/es/focus/10-earlyentry.mdx";
import * as Focus11AdulteducationEs from "./content/es/focus/11-adulteducation.mdx";
import * as Focus12LowperformanceEs from "./content/es/focus/12-lowperformance.mdx";
import * as Focus13SpendingEs from "./content/es/focus/13-Spending.mdx";
import * as Focus14HouseholdwealthEs from "./content/es/focus/14-householdwealth.mdx";
import * as Focus15TaxrevenueEs from "./content/es/focus/15-taxrevenue.mdx";
import * as Focus16ScholarshipsEs from "./content/es/focus/16-scholarships.mdx";
import * as Focus17StudentdebtEs from "./content/es/focus/17-studentdebt.mdx";
import * as Focus18ClimatechangeEs from "./content/es/focus/18-climatechange.mdx";
import * as Focus19NumeracyskillsEs from "./content/es/focus/19-numeracyskills.mdx";
import * as Focus20ComputationalthinkingEs from "./content/es/focus/20-computationalthinking.mdx";
import * as Focus21WritingtoolsEs from "./content/es/focus/21-writingtools.mdx";
import * as Focus22MicrodredentialsEs from "./content/es/focus/22-microdredentials.mdx";
import * as Focus23FirstgenerationEs from "./content/es/focus/23-firstgeneration.mdx";
import * as Focus24ReadingspeedEs from "./content/es/focus/24-readingspeed.mdx";
import * as Focus25SchoolbuildingEs from "./content/es/focus/25-schoolbuilding.mdx";
import * as Focus26SolarenergyEs from "./content/es/focus/26-solarenergy.mdx";
import * as Focus27OnlinesearchEs from "./content/es/focus/27-onlinesearch.mdx";
import * as Focus28MathanxietyEs from "./content/es/focus/28-mathanxiety.mdx";
import * as Focus29EcceleadersEs from "./content/es/focus/29-ecceleaders.mdx";
import * as Focus30TeachleadershipEs from "./content/es/focus/30-teachleadership.mdx";
import * as Focus31PeereffectsEs from "./content/es/focus/31-peereffects.mdx";
import * as Focus32CiviceduEs from "./content/es/focus/32-civicedu.mdx";
import * as Focus33ClimateinfraEs from "./content/es/focus/33-climateinfra.mdx";
import * as Focus34NsascholarshipsEs from "./content/es/focus/34-NSAscholarships.mdx";
import * as Focus35TeachershortageEs from "./content/es/focus/35-teachershortage.mdx";
import * as Focus36PrincipalsalariesEs from "./content/es/focus/36-principalsalaries.mdx";
import * as Focus37ClimatefinEs from "./content/es/focus/37-climatefin.mdx";
import * as Focus0TemplateFr from "./content/fr/focus/0-template.mdx";
import * as Focus1DemandFr from "./content/fr/focus/1-demand.mdx";
import * as Focus2TeachoutfieldFr from "./content/fr/focus/2-teachoutfield.mdx";
import * as Focus3CalendarFr from "./content/fr/focus/3-calendar.mdx";
import * as Focus4SinglesexschoolsFr from "./content/fr/focus/4-singlesexschools.mdx";
import * as Focus5InfrastructureFr from "./content/fr/focus/5-infrastructure.mdx";
import * as Focus6LearningnotlinearFr from "./content/fr/focus/6-learningnotlinear.mdx";
import * as Focus7SafeschoolsFr from "./content/fr/focus/7-safeschools.mdx";
import * as Focus8ScholarshipsssaFr from "./content/fr/focus/8-scholarshipsSSA.mdx";
import * as Focus9IndigenousFr from "./content/fr/focus/9-indigenous.mdx";
import * as Focus10EarlyentryFr from "./content/fr/focus/10-earlyentry.mdx";
import * as Focus11AdulteducationFr from "./content/fr/focus/11-adulteducation.mdx";
import * as Focus12LowperformanceFr from "./content/fr/focus/12-lowperformance.mdx";
import * as Focus13SpendingFr from "./content/fr/focus/13-Spending.mdx";
import * as Focus14HouseholdwealthFr from "./content/fr/focus/14-householdwealth.mdx";
import * as Focus15TaxrevenueFr from "./content/fr/focus/15-taxrevenue.mdx";
import * as Focus16ScholarshipsFr from "./content/fr/focus/16-scholarships.mdx";
import * as Focus17StudentdebtFr from "./content/fr/focus/17-studentdebt.mdx";
import * as Focus18ClimatechangeFr from "./content/fr/focus/18-climatechange.mdx";
import * as Focus19NumeracyskillsFr from "./content/fr/focus/19-numeracyskills.mdx";
import * as Focus20ComputationalthinkingFr from "./content/fr/focus/20-computationalthinking.mdx";
import * as Focus21WritingtoolsFr from "./content/fr/focus/21-writingtools.mdx";
import * as Focus22MicrodredentialsFr from "./content/fr/focus/22-microdredentials.mdx";
import * as Focus23FirstgenerationFr from "./content/fr/focus/23-firstgeneration.mdx";
import * as Focus24ReadingspeedFr from "./content/fr/focus/24-readingspeed.mdx";
import * as Focus25SchoolbuildingFr from "./content/fr/focus/25-schoolbuilding.mdx";
import * as Focus26SolarenergyFr from "./content/fr/focus/26-solarenergy.mdx";
import * as Focus27OnlinesearchFr from "./content/fr/focus/27-onlinesearch.mdx";
import * as Focus28MathanxietyFr from "./content/fr/focus/28-mathanxiety.mdx";
import * as Focus29EcceleadersFr from "./content/fr/focus/29-ecceleaders.mdx";
import * as Focus30TeachleadershipFr from "./content/fr/focus/30-teachleadership.mdx";
import * as Focus31PeereffectsFr from "./content/fr/focus/31-peereffects.mdx";
import * as Focus32CiviceduFr from "./content/fr/focus/32-civicedu.mdx";
import * as Focus33ClimateinfraFr from "./content/fr/focus/33-climateinfra.mdx";
import * as Focus34NsascholarshipsFr from "./content/fr/focus/34-NSAscholarships.mdx";
import * as Focus35TeachershortageFr from "./content/fr/focus/35-teachershortage.mdx";
import * as Focus36PrincipalsalariesFr from "./content/fr/focus/36-principalsalaries.mdx";
import * as Focus37ClimatefinFr from "./content/fr/focus/37-climatefin.mdx";
import * as Focus0TemplateRu from "./content/ru/focus/0-template.mdx";
import * as Focus1DemandRu from "./content/ru/focus/1-demand.mdx";
import * as Focus2TeachoutfieldRu from "./content/ru/focus/2-teachoutfield.mdx";
import * as Focus3CalendarRu from "./content/ru/focus/3-calendar.mdx";
import * as Focus4SinglesexschoolsRu from "./content/ru/focus/4-singlesexschools.mdx";
import * as Focus5InfrastructureRu from "./content/ru/focus/5-infrastructure.mdx";
import * as Focus6LearningnotlinearRu from "./content/ru/focus/6-learningnotlinear.mdx";
import * as Focus7SafeschoolsRu from "./content/ru/focus/7-safeschools.mdx";
import * as Focus8ScholarshipsssaRu from "./content/ru/focus/8-scholarshipsSSA.mdx";
import * as Focus9IndigenousRu from "./content/ru/focus/9-indigenous.mdx";
import * as Focus10EarlyentryRu from "./content/ru/focus/10-earlyentry.mdx";
import * as Focus11AdulteducationRu from "./content/ru/focus/11-adulteducation.mdx";
import * as Focus12LowperformanceRu from "./content/ru/focus/12-lowperformance.mdx";
import * as Focus13SpendingRu from "./content/ru/focus/13-Spending.mdx";
import * as Focus14HouseholdwealthRu from "./content/ru/focus/14-householdwealth.mdx";
import * as Focus15TaxrevenueRu from "./content/ru/focus/15-taxrevenue.mdx";
import * as Focus16ScholarshipsRu from "./content/ru/focus/16-scholarships.mdx";
import * as Focus17StudentdebtRu from "./content/ru/focus/17-studentdebt.mdx";
import * as Focus18ClimatechangeRu from "./content/ru/focus/18-climatechange.mdx";
import * as Focus19NumeracyskillsRu from "./content/ru/focus/19-numeracyskills.mdx";
import * as Focus20ComputationalthinkingRu from "./content/ru/focus/20-computationalthinking.mdx";
import * as Focus21WritingtoolsRu from "./content/ru/focus/21-writingtools.mdx";
import * as Focus22MicrodredentialsRu from "./content/ru/focus/22-microdredentials.mdx";
import * as Focus23FirstgenerationRu from "./content/ru/focus/23-firstgeneration.mdx";
import * as Focus24ReadingspeedRu from "./content/ru/focus/24-readingspeed.mdx";
import * as Focus25SchoolbuildingRu from "./content/ru/focus/25-schoolbuilding.mdx";
import * as Focus26SolarenergyRu from "./content/ru/focus/26-solarenergy.mdx";
import * as Focus27OnlinesearchRu from "./content/ru/focus/27-onlinesearch.mdx";
import * as Focus28MathanxietyRu from "./content/ru/focus/28-mathanxiety.mdx";
import * as Focus29EcceleadersRu from "./content/ru/focus/29-ecceleaders.mdx";
import * as Focus30TeachleadershipRu from "./content/ru/focus/30-teachleadership.mdx";
import * as Focus31PeereffectsRu from "./content/ru/focus/31-peereffects.mdx";
import * as Focus32CiviceduRu from "./content/ru/focus/32-civicedu.mdx";
import * as Focus33ClimateinfraRu from "./content/ru/focus/33-climateinfra.mdx";
import * as Focus34NsascholarshipsRu from "./content/ru/focus/34-NSAscholarships.mdx";
import * as Focus35TeachershortageRu from "./content/ru/focus/35-teachershortage.mdx";
import * as Focus36PrincipalsalariesRu from "./content/ru/focus/36-principalsalaries.mdx";
import * as Focus37ClimatefinRu from "./content/ru/focus/37-climatefin.mdx";
import * as Focus0TemplateZh from "./content/zh/focus/0-template.mdx";
import * as Focus1DemandZh from "./content/zh/focus/1-demand.mdx";
import * as Focus2TeachoutfieldZh from "./content/zh/focus/2-teachoutfield.mdx";
import * as Focus3CalendarZh from "./content/zh/focus/3-calendar.mdx";
import * as Focus4SinglesexschoolsZh from "./content/zh/focus/4-singlesexschools.mdx";
import * as Focus5InfrastructureZh from "./content/zh/focus/5-infrastructure.mdx";
import * as Focus6LearningnotlinearZh from "./content/zh/focus/6-learningnotlinear.mdx";
import * as Focus7SafeschoolsZh from "./content/zh/focus/7-safeschools.mdx";
import * as Focus8ScholarshipsssaZh from "./content/zh/focus/8-scholarshipsSSA.mdx";
import * as Focus9IndigenousZh from "./content/zh/focus/9-indigenous.mdx";
import * as Focus10EarlyentryZh from "./content/zh/focus/10-earlyentry.mdx";
import * as Focus11AdulteducationZh from "./content/zh/focus/11-adulteducation.mdx";
import * as Focus12LowperformanceZh from "./content/zh/focus/12-lowperformance.mdx";
import * as Focus13SpendingZh from "./content/zh/focus/13-Spending.mdx";
import * as Focus14HouseholdwealthZh from "./content/zh/focus/14-householdwealth.mdx";
import * as Focus15TaxrevenueZh from "./content/zh/focus/15-taxrevenue.mdx";
import * as Focus16ScholarshipsZh from "./content/zh/focus/16-scholarships.mdx";
import * as Focus17StudentdebtZh from "./content/zh/focus/17-studentdebt.mdx";
import * as Focus18ClimatechangeZh from "./content/zh/focus/18-climatechange.mdx";
import * as Focus19NumeracyskillsZh from "./content/zh/focus/19-numeracyskills.mdx";
import * as Focus20ComputationalthinkingZh from "./content/zh/focus/20-computationalthinking.mdx";
import * as Focus21WritingtoolsZh from "./content/zh/focus/21-writingtools.mdx";
import * as Focus22MicrodredentialsZh from "./content/zh/focus/22-microdredentials.mdx";
import * as Focus23FirstgenerationZh from "./content/zh/focus/23-firstgeneration.mdx";
import * as Focus24ReadingspeedZh from "./content/zh/focus/24-readingspeed.mdx";
import * as Focus25SchoolbuildingZh from "./content/zh/focus/25-schoolbuilding.mdx";
import * as Focus26SolarenergyZh from "./content/zh/focus/26-solarenergy.mdx";
import * as Focus27OnlinesearchZh from "./content/zh/focus/27-onlinesearch.mdx";
import * as Focus28MathanxietyZh from "./content/zh/focus/28-mathanxiety.mdx";
import * as Focus29EcceleadersZh from "./content/zh/focus/29-ecceleaders.mdx";
import * as Focus30TeachleadershipZh from "./content/zh/focus/30-teachleadership.mdx";
import * as Focus31PeereffectsZh from "./content/zh/focus/31-peereffects.mdx";
import * as Focus32CiviceduZh from "./content/zh/focus/32-civicedu.mdx";
import * as Focus33ClimateinfraZh from "./content/zh/focus/33-climateinfra.mdx";
import * as Focus34NsascholarshipsZh from "./content/zh/focus/34-NSAscholarships.mdx";
import * as Focus35TeachershortageZh from "./content/zh/focus/35-teachershortage.mdx";
import * as Focus36PrincipalsalariesZh from "./content/zh/focus/36-principalsalaries.mdx";
import * as Focus37ClimatefinZh from "./content/zh/focus/37-climatefin.mdx";

export const articleLocaleContents: Record<string, Record<string, MDXModule>> = {
  ar: {
    "0-template": Focus0TemplateAr,
    "1-demand": Focus1DemandAr,
    "10-earlyentry": Focus10EarlyentryAr,
    "11-adulteducation": Focus11AdulteducationAr,
    "12-lowperformance": Focus12LowperformanceAr,
    "13-Spending": Focus13SpendingAr,
    "14-householdwealth": Focus14HouseholdwealthAr,
    "15-taxrevenue": Focus15TaxrevenueAr,
    "16-scholarships": Focus16ScholarshipsAr,
    "17-studentdebt": Focus17StudentdebtAr,
    "18-climatechange": Focus18ClimatechangeAr,
    "19-numeracyskills": Focus19NumeracyskillsAr,
    "2-teachoutfield": Focus2TeachoutfieldAr,
    "20-computationalthinking": Focus20ComputationalthinkingAr,
    "21-writingtools": Focus21WritingtoolsAr,
    "22-microdredentials": Focus22MicrodredentialsAr,
    "23-firstgeneration": Focus23FirstgenerationAr,
    "24-readingspeed": Focus24ReadingspeedAr,
    "25-schoolbuilding": Focus25SchoolbuildingAr,
    "26-solarenergy": Focus26SolarenergyAr,
    "27-onlinesearch": Focus27OnlinesearchAr,
    "28-mathanxiety": Focus28MathanxietyAr,
    "29-ecceleaders": Focus29EcceleadersAr,
    "3-calendar": Focus3CalendarAr,
    "30-teachleadership": Focus30TeachleadershipAr,
    "31-peereffects": Focus31PeereffectsAr,
    "32-civicedu": Focus32CiviceduAr,
    "33-climateinfra": Focus33ClimateinfraAr,
    "34-NSAscholarships": Focus34NsascholarshipsAr,
    "35-teachershortage": Focus35TeachershortageAr,
    "36-principalsalaries": Focus36PrincipalsalariesAr,
    "37-climatefin": Focus37ClimatefinAr,
    "4-singlesexschools": Focus4SinglesexschoolsAr,
    "5-infrastructure": Focus5InfrastructureAr,
    "6-learningnotlinear": Focus6LearningnotlinearAr,
    "7-safeschools": Focus7SafeschoolsAr,
    "8-scholarshipsSSA": Focus8ScholarshipsssaAr,
    "9-indigenous": Focus9IndigenousAr,
  },
  de: {
    "0-template": Focus0TemplateDe,
    "1-demand": Focus1DemandDe,
    "10-earlyentry": Focus10EarlyentryDe,
    "11-adulteducation": Focus11AdulteducationDe,
    "12-lowperformance": Focus12LowperformanceDe,
    "13-Spending": Focus13SpendingDe,
    "14-householdwealth": Focus14HouseholdwealthDe,
    "15-taxrevenue": Focus15TaxrevenueDe,
    "16-scholarships": Focus16ScholarshipsDe,
    "17-studentdebt": Focus17StudentdebtDe,
    "18-climatechange": Focus18ClimatechangeDe,
    "19-numeracyskills": Focus19NumeracyskillsDe,
    "2-teachoutfield": Focus2TeachoutfieldDe,
    "20-computationalthinking": Focus20ComputationalthinkingDe,
    "21-writingtools": Focus21WritingtoolsDe,
    "22-microdredentials": Focus22MicrodredentialsDe,
    "23-firstgeneration": Focus23FirstgenerationDe,
    "24-readingspeed": Focus24ReadingspeedDe,
    "25-schoolbuilding": Focus25SchoolbuildingDe,
    "26-solarenergy": Focus26SolarenergyDe,
    "27-onlinesearch": Focus27OnlinesearchDe,
    "28-mathanxiety": Focus28MathanxietyDe,
    "29-ecceleaders": Focus29EcceleadersDe,
    "3-calendar": Focus3CalendarDe,
    "30-teachleadership": Focus30TeachleadershipDe,
    "31-peereffects": Focus31PeereffectsDe,
    "32-civicedu": Focus32CiviceduDe,
    "33-climateinfra": Focus33ClimateinfraDe,
    "34-NSAscholarships": Focus34NsascholarshipsDe,
    "35-teachershortage": Focus35TeachershortageDe,
    "36-principalsalaries": Focus36PrincipalsalariesDe,
    "37-climatefin": Focus37ClimatefinDe,
    "4-singlesexschools": Focus4SinglesexschoolsDe,
    "5-infrastructure": Focus5InfrastructureDe,
    "6-learningnotlinear": Focus6LearningnotlinearDe,
    "7-safeschools": Focus7SafeschoolsDe,
    "8-scholarshipsSSA": Focus8ScholarshipsssaDe,
    "9-indigenous": Focus9IndigenousDe,
  },
  en: {
    "0-template": Focus0TemplateEn,
    "1-demand": Focus1DemandEn,
    "10-earlyentry": Focus10EarlyentryEn,
    "11-adulteducation": Focus11AdulteducationEn,
    "12-lowperformance": Focus12LowperformanceEn,
    "13-Spending": Focus13SpendingEn,
    "14-householdwealth": Focus14HouseholdwealthEn,
    "15-taxrevenue": Focus15TaxrevenueEn,
    "16-scholarships": Focus16ScholarshipsEn,
    "17-studentdebt": Focus17StudentdebtEn,
    "18-climatechange": Focus18ClimatechangeEn,
    "19-numeracyskills": Focus19NumeracyskillsEn,
    "2-teachoutfield": Focus2TeachoutfieldEn,
    "20-computationalthinking": Focus20ComputationalthinkingEn,
    "21-writingtools": Focus21WritingtoolsEn,
    "22-microdredentials": Focus22MicrodredentialsEn,
    "23-firstgeneration": Focus23FirstgenerationEn,
    "24-readingspeed": Focus24ReadingspeedEn,
    "25-schoolbuilding": Focus25SchoolbuildingEn,
    "26-solarenergy": Focus26SolarenergyEn,
    "27-onlinesearch": Focus27OnlinesearchEn,
    "28-mathanxiety": Focus28MathanxietyEn,
    "29-ecceleaders": Focus29EcceleadersEn,
    "3-calendar": Focus3CalendarEn,
    "30-teachleadership": Focus30TeachleadershipEn,
    "31-peereffects": Focus31PeereffectsEn,
    "32-civicedu": Focus32CiviceduEn,
    "33-climateinfra": Focus33ClimateinfraEn,
    "34-NSAscholarships": Focus34NsascholarshipsEn,
    "35-teachershortage": Focus35TeachershortageEn,
    "36-principalsalaries": Focus36PrincipalsalariesEn,
    "37-climatefin": Focus37ClimatefinEn,
    "4-singlesexschools": Focus4SinglesexschoolsEn,
    "5-infrastructure": Focus5InfrastructureEn,
    "6-learningnotlinear": Focus6LearningnotlinearEn,
    "7-safeschools": Focus7SafeschoolsEn,
    "8-scholarshipsSSA": Focus8ScholarshipsssaEn,
    "9-indigenous": Focus9IndigenousEn,
  },
  es: {
    "0-template": Focus0TemplateEs,
    "1-demand": Focus1DemandEs,
    "10-earlyentry": Focus10EarlyentryEs,
    "11-adulteducation": Focus11AdulteducationEs,
    "12-lowperformance": Focus12LowperformanceEs,
    "13-Spending": Focus13SpendingEs,
    "14-householdwealth": Focus14HouseholdwealthEs,
    "15-taxrevenue": Focus15TaxrevenueEs,
    "16-scholarships": Focus16ScholarshipsEs,
    "17-studentdebt": Focus17StudentdebtEs,
    "18-climatechange": Focus18ClimatechangeEs,
    "19-numeracyskills": Focus19NumeracyskillsEs,
    "2-teachoutfield": Focus2TeachoutfieldEs,
    "20-computationalthinking": Focus20ComputationalthinkingEs,
    "21-writingtools": Focus21WritingtoolsEs,
    "22-microdredentials": Focus22MicrodredentialsEs,
    "23-firstgeneration": Focus23FirstgenerationEs,
    "24-readingspeed": Focus24ReadingspeedEs,
    "25-schoolbuilding": Focus25SchoolbuildingEs,
    "26-solarenergy": Focus26SolarenergyEs,
    "27-onlinesearch": Focus27OnlinesearchEs,
    "28-mathanxiety": Focus28MathanxietyEs,
    "29-ecceleaders": Focus29EcceleadersEs,
    "3-calendar": Focus3CalendarEs,
    "30-teachleadership": Focus30TeachleadershipEs,
    "31-peereffects": Focus31PeereffectsEs,
    "32-civicedu": Focus32CiviceduEs,
    "33-climateinfra": Focus33ClimateinfraEs,
    "34-NSAscholarships": Focus34NsascholarshipsEs,
    "35-teachershortage": Focus35TeachershortageEs,
    "36-principalsalaries": Focus36PrincipalsalariesEs,
    "37-climatefin": Focus37ClimatefinEs,
    "4-singlesexschools": Focus4SinglesexschoolsEs,
    "5-infrastructure": Focus5InfrastructureEs,
    "6-learningnotlinear": Focus6LearningnotlinearEs,
    "7-safeschools": Focus7SafeschoolsEs,
    "8-scholarshipsSSA": Focus8ScholarshipsssaEs,
    "9-indigenous": Focus9IndigenousEs,
  },
  fr: {
    "0-template": Focus0TemplateFr,
    "1-demand": Focus1DemandFr,
    "10-earlyentry": Focus10EarlyentryFr,
    "11-adulteducation": Focus11AdulteducationFr,
    "12-lowperformance": Focus12LowperformanceFr,
    "13-Spending": Focus13SpendingFr,
    "14-householdwealth": Focus14HouseholdwealthFr,
    "15-taxrevenue": Focus15TaxrevenueFr,
    "16-scholarships": Focus16ScholarshipsFr,
    "17-studentdebt": Focus17StudentdebtFr,
    "18-climatechange": Focus18ClimatechangeFr,
    "19-numeracyskills": Focus19NumeracyskillsFr,
    "2-teachoutfield": Focus2TeachoutfieldFr,
    "20-computationalthinking": Focus20ComputationalthinkingFr,
    "21-writingtools": Focus21WritingtoolsFr,
    "22-microdredentials": Focus22MicrodredentialsFr,
    "23-firstgeneration": Focus23FirstgenerationFr,
    "24-readingspeed": Focus24ReadingspeedFr,
    "25-schoolbuilding": Focus25SchoolbuildingFr,
    "26-solarenergy": Focus26SolarenergyFr,
    "27-onlinesearch": Focus27OnlinesearchFr,
    "28-mathanxiety": Focus28MathanxietyFr,
    "29-ecceleaders": Focus29EcceleadersFr,
    "3-calendar": Focus3CalendarFr,
    "30-teachleadership": Focus30TeachleadershipFr,
    "31-peereffects": Focus31PeereffectsFr,
    "32-civicedu": Focus32CiviceduFr,
    "33-climateinfra": Focus33ClimateinfraFr,
    "34-NSAscholarships": Focus34NsascholarshipsFr,
    "35-teachershortage": Focus35TeachershortageFr,
    "36-principalsalaries": Focus36PrincipalsalariesFr,
    "37-climatefin": Focus37ClimatefinFr,
    "4-singlesexschools": Focus4SinglesexschoolsFr,
    "5-infrastructure": Focus5InfrastructureFr,
    "6-learningnotlinear": Focus6LearningnotlinearFr,
    "7-safeschools": Focus7SafeschoolsFr,
    "8-scholarshipsSSA": Focus8ScholarshipsssaFr,
    "9-indigenous": Focus9IndigenousFr,
  },
  ru: {
    "0-template": Focus0TemplateRu,
    "1-demand": Focus1DemandRu,
    "10-earlyentry": Focus10EarlyentryRu,
    "11-adulteducation": Focus11AdulteducationRu,
    "12-lowperformance": Focus12LowperformanceRu,
    "13-Spending": Focus13SpendingRu,
    "14-householdwealth": Focus14HouseholdwealthRu,
    "15-taxrevenue": Focus15TaxrevenueRu,
    "16-scholarships": Focus16ScholarshipsRu,
    "17-studentdebt": Focus17StudentdebtRu,
    "18-climatechange": Focus18ClimatechangeRu,
    "19-numeracyskills": Focus19NumeracyskillsRu,
    "2-teachoutfield": Focus2TeachoutfieldRu,
    "20-computationalthinking": Focus20ComputationalthinkingRu,
    "21-writingtools": Focus21WritingtoolsRu,
    "22-microdredentials": Focus22MicrodredentialsRu,
    "23-firstgeneration": Focus23FirstgenerationRu,
    "24-readingspeed": Focus24ReadingspeedRu,
    "25-schoolbuilding": Focus25SchoolbuildingRu,
    "26-solarenergy": Focus26SolarenergyRu,
    "27-onlinesearch": Focus27OnlinesearchRu,
    "28-mathanxiety": Focus28MathanxietyRu,
    "29-ecceleaders": Focus29EcceleadersRu,
    "3-calendar": Focus3CalendarRu,
    "30-teachleadership": Focus30TeachleadershipRu,
    "31-peereffects": Focus31PeereffectsRu,
    "32-civicedu": Focus32CiviceduRu,
    "33-climateinfra": Focus33ClimateinfraRu,
    "34-NSAscholarships": Focus34NsascholarshipsRu,
    "35-teachershortage": Focus35TeachershortageRu,
    "36-principalsalaries": Focus36PrincipalsalariesRu,
    "37-climatefin": Focus37ClimatefinRu,
    "4-singlesexschools": Focus4SinglesexschoolsRu,
    "5-infrastructure": Focus5InfrastructureRu,
    "6-learningnotlinear": Focus6LearningnotlinearRu,
    "7-safeschools": Focus7SafeschoolsRu,
    "8-scholarshipsSSA": Focus8ScholarshipsssaRu,
    "9-indigenous": Focus9IndigenousRu,
  },
  zh: {
    "0-template": Focus0TemplateZh,
    "1-demand": Focus1DemandZh,
    "10-earlyentry": Focus10EarlyentryZh,
    "11-adulteducation": Focus11AdulteducationZh,
    "12-lowperformance": Focus12LowperformanceZh,
    "13-Spending": Focus13SpendingZh,
    "14-householdwealth": Focus14HouseholdwealthZh,
    "15-taxrevenue": Focus15TaxrevenueZh,
    "16-scholarships": Focus16ScholarshipsZh,
    "17-studentdebt": Focus17StudentdebtZh,
    "18-climatechange": Focus18ClimatechangeZh,
    "19-numeracyskills": Focus19NumeracyskillsZh,
    "2-teachoutfield": Focus2TeachoutfieldZh,
    "20-computationalthinking": Focus20ComputationalthinkingZh,
    "21-writingtools": Focus21WritingtoolsZh,
    "22-microdredentials": Focus22MicrodredentialsZh,
    "23-firstgeneration": Focus23FirstgenerationZh,
    "24-readingspeed": Focus24ReadingspeedZh,
    "25-schoolbuilding": Focus25SchoolbuildingZh,
    "26-solarenergy": Focus26SolarenergyZh,
    "27-onlinesearch": Focus27OnlinesearchZh,
    "28-mathanxiety": Focus28MathanxietyZh,
    "29-ecceleaders": Focus29EcceleadersZh,
    "3-calendar": Focus3CalendarZh,
    "30-teachleadership": Focus30TeachleadershipZh,
    "31-peereffects": Focus31PeereffectsZh,
    "32-civicedu": Focus32CiviceduZh,
    "33-climateinfra": Focus33ClimateinfraZh,
    "34-NSAscholarships": Focus34NsascholarshipsZh,
    "35-teachershortage": Focus35TeachershortageZh,
    "36-principalsalaries": Focus36PrincipalsalariesZh,
    "37-climatefin": Focus37ClimatefinZh,
    "4-singlesexschools": Focus4SinglesexschoolsZh,
    "5-infrastructure": Focus5InfrastructureZh,
    "6-learningnotlinear": Focus6LearningnotlinearZh,
    "7-safeschools": Focus7SafeschoolsZh,
    "8-scholarshipsSSA": Focus8ScholarshipsssaZh,
    "9-indigenous": Focus9IndigenousZh,
  },
};

export const getFocusMetadata = (alias: RAlias, locale: Locale) => {
  const { frontmatter } = articleLocaleContents[locale][alias];
  return {
    alias,
    title: frontmatter.title,
    lead: frontmatter.lead,
    year: frontmatter.year,
    article: frontmatter.article,
  };
};
